import styled from "styled-components";
import { renderFounders } from "./FoundersData";
// import { renderTeam } from "./TeamData";
import theme from "../../styles/theme";

import AboutUsBackground from "../../assets/AboutUsBackground.png";
import F1ManagerImage from "../../assets/f1manager.jpg";

import BlockTitle from "../../components/Common/BlockTitle";
import PageHeading from "../../components/Common/PageHeading";
import AboutUsSEO from "../../components/SEO/AboutUsSEO";

const StyledImgTop = styled.img`
  position: absolute;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  left: 0px;
  height: 150px;
  object-fit: cover;
  opacity: 1;
  @media (max-width: ${theme.breakpointsCustom.sm}px) {
    width: auto;
  }
`;

const ImageContainer = styled.div`
  position: absolute;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  left: 0px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Title = styled.div`
  margin: 0;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-family: "Montserrat", sans-serif;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  position: absolute;
`;

const Section1 = styled.div`
  color: white;
  font-size: 24px;
  padding-top: 220px;
  position: relative;
`;

const Section3 = styled.div`
  padding-top: 60px;
  position: relative;
`;

const Section1ContextContainer = styled.div`
display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    @media (max-width: ${theme.breakpointsCustom.lg}px) {
      flex-direction: column-reverse;
    }
}
`;

const Section1TextContainer = styled.div``;

const Section1TextContainerDiscription = styled.div`
  font-size: 22px;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  max-width: 550px;
`;

const StyledImgSection1Container = styled.div``;

const StyledImgSection1 = styled.img`
  max-width: 616px;
  width: 100%;
  opacity: 1;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
`;

const Founders = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  grid-row-gap: 50px;
  font-family: "Montserrat", sans-serif;
  @media (max-width: ${theme.breakpointsCustom.lg}px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: ${theme.breakpointsCustom.md}px) {
    grid-template-columns: 1fr;
  }
`;

const AboutUsPage = () => {
  return (
    <>
      <AboutUsSEO />
      <div>
        <ImageContainer>
          <Title as="h1">Про нас</Title>
          <StyledImgTop src={AboutUsBackground} />
        </ImageContainer>

        <Section1>
          <Section1ContextContainer>
            <StyledImgSection1Container>
              <StyledImgSection1 src={F1ManagerImage} />
            </StyledImgSection1Container>
            <Section1TextContainer>
              <Section1TextContainerDiscription>
                <p>
                  Slick Racing Ukraine – спільнота любителів віртуального автоспорту створена у 2022
                  році. Наші турніри створюють унікальний досвід як для учасників, так і для
                  вболівальників. Кожен турнір вирізняється ретельною організацією та забезпечує
                  максимальне занурення у світ перегонів..
                </p>
              </Section1TextContainerDiscription>
            </Section1TextContainer>
          </Section1ContextContainer>
        </Section1>

        <Section3>
          <BlockTitle>
            <PageHeading as="h2">Команда</PageHeading>
          </BlockTitle>
          <Founders>{renderFounders()}</Founders>
        </Section3>
        {/* <Section3>
          <BlockTitle>Команда</BlockTitle>
          <Founders>{renderTeam()}</Founders>
        </Section3> */}
      </div>
    </>
  );
};

export default AboutUsPage;
